module.exports = __webpack_public_path__ + "img/public-folder-lllustration.ab5ce2ac.svg";